import { useEffect, useState } from "react";
import matvogn from "../assets/images/matvogn.jpg";
import bruktbutikk from "../assets/images/bruktbutikk.png";

export default function Bedrifter() {
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(
                "https://2btpaefd.api.sanity.io/v2025-04-10/data/query/production?query=*%5B_type+%3D%3D+%22page%22%5D+%7B%0A++title%2C+text%0A%7D&perspective=drafts"
            );
            const json = await response.json();
            setData(json.result);
        };

        fetchData();
    }, []);

    return (
        <section id="salgsarenaer" className="px-4 py-24 max-w-7xl mx-auto text-center scroll-mt-24">
            <p className="text-green-600 font-normal mb-2">Stedene der vi selger og skaper relasjoner</p>
            <h1 className="text-4xl font-bold mb-12">{data?.[4]?.title || "Salgsarenaer"}</h1>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                {/* Matvogn Card */}
                <div className="flex flex-col items-center">
                    <img src={matvogn} alt="Matvogn" className="rounded-xl w-full object-cover max-h-[300px]" />
                    <h2 className="font-bold text-lg mt-6">{data?.[2]?.title || "Matvogn"}</h2>
                    <p className="mt-2 text-gray-700 max-w-md">{data?.[2]?.text || "Lasting..."}</p>
                </div>

                {/* Bruktbutikk Card */}
                <div className="flex flex-col items-center">
                    <img src={bruktbutikk} alt="Bruktbutikk" className="rounded-xl w-full object-cover max-h-[300px]" />
                    <h2 className="font-bold text-lg mt-6">{data?.[1]?.title || "Bruktbutikken"}</h2>
                    <p className="mt-2 text-gray-700 max-w-md">{data?.[1]?.text || "Lasting..."}</p>
                </div>
            </div>
        </section>
    );
}
